import * as Sentry from "@sentry/react";

export const initSentry = () => {
  // Only initialize Sentry in production
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: "https://f473ec9dbf58bca0ed9126d511c937b0@o4509325787529216.ingest.de.sentry.io/4509325789233232",
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of transactions, adjust in production
      // Session Replay
      replaysSessionSampleRate: 0.1, // Sample rate for session replays
      replaysOnErrorSampleRate: 1.0, // Sample rate for error replays
      // Setting this option to true will send default PII data to Sentry
      sendDefaultPii: true,
      environment: import.meta.env.MODE,
      // Set the release name
      release: "praxi@1.0.0",
    });
  }
}; 